module.exports = __webpack_public_path__ + "static/media/quad.fcce8c72.svg";